import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule, PopoverController } from "@ionic/angular";
import { IonSearchbar } from "@ionic/angular/standalone";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from "rxjs";
import { FilterDataPipe } from "src/app/pipes/filter-data.pipe";
import { FilterKeywordsPipe } from "src/app/pipes/filter-keywords";
import { HighlightSearchPipe } from "src/app/pipes/highlight-search.pipe";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { LobbyNavigator } from "src/app/services/lobby/lobby-navigator.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "../menu/navigator";
import { EventsService } from "src/app/services/event/event.service";


@Component({
    selector: 'app-searchbar',
    templateUrl: './searchbar.component.html',
    styleUrls: ['./searchbar.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        IonicModule,
        FilterDataPipe,
        FilterKeywordsPipe,
        HighlightSearchPipe,
    ]
})

export class SearchbarComponent implements OnInit, OnDestroy {
    @ViewChild('inputEl', { static: true }) inputElRef: IonSearchbar;
    @Output() keySelected = new EventEmitter();
    @Input() keywords: any[] = [];

    public subscriptionFocus: Subscription;
    public focus$: Subject<string> = new Subject<string>();

    public allGamesList: any[] = [];
    public imagesPath: string;
    public isAuthenticated = false;
    public keyWordsArray: any;
    public keyWordQueryChanged: Subject<any> = new Subject<any>();
    public showKeyWords: boolean = true;


    constructor(
        private readonly gameHubControllerService: GameHubControllerService,
        private readonly lobbyNavigator: LobbyNavigator,
        private readonly lobbyService: LobbyService,
        private readonly navigator: Navigator,
        private readonly popoverController: PopoverController,
        private readonly userSession: UserSessionService,
        private events: EventsService,
    ) {

        this.keyWordQueryChanged
            .pipe(debounceTime(100), distinctUntilChanged())
            .subscribe(model => {
                this.keyWordsArray = model;
            });

        this.subscriptionFocus = this.focus$
            .pipe(debounceTime(25))
            .subscribe(
                (ev) => {
                    this.onFocus(ev)
                }
            );

    }

    clearSearch() {
        this.onFieldChange('');
    }

    ngOnInit(): void {
        this.imagesPath = this.lobbyService.galleryImagePath;

        this.userSession.getCustomer().subscribe((customer) => {
            this.userSession.isAuthenticated().then(res => {
                this.isAuthenticated = res;
            })
        });

        this.lobbyNavigator.getAllGameSubject().subscribe(list => {
            this.allGamesList = list;
        });
    }

    onFieldChange(keywordQuery) {
        this.showKeyWords = false;
        if (keywordQuery == "") {
            this.showKeyWords = true;
        }
        this.keyWordQueryChanged.next(keywordQuery);
    }

    onFocus(ev: any) {
        this.showKeyWords = true;
    }

    onDataSelected(key) {
        // this.showKeyWords = false;
        this.keySelected.emit(key);
        return this.onCloseSearchbar();
    }

    onCloseSearchbar() {
        // this.keyWordsArray = '';
        // this.inputElRef.value = '';
        this.clearSearch();
        this.showKeyWords = true;
        this.popoverController.dismiss();
    }

    public onSearchClick(gameData: any) {
        this.onCloseSearchbar();
        if (!this.isAuthenticated) {
            this.lobbyService.setWaitingGameData(gameData);
            return this.onLogin(gameData);
        }

        this.events.publish("event:game:close");
        return setTimeout(() => this.gameHubControllerService.launchCasinoGame(gameData), 300);
    }

    private onLogin(gameData?: any) {
        return this.navigator?.navigateTo("LoginComponent");
    }

    ngOnDestroy() {
        this.subscriptionFocus.unsubscribe();
    }
}